import { render, staticRenderFns } from "./utmList.vue?vue&type=template&id=9d01bf74"
import script from "./utmList.vue?vue&type=script&lang=js"
export * from "./utmList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports